<div class="general-container">
  <ng-container *ngIf="isLoading else fligthsUpsellCont">
    <app-upsell-placeholder></app-upsell-placeholder>
  </ng-container>
  <ng-template #fligthsUpsellCont>
    <div class="header-container">
      <div>
        <span class="title">
          {{ 'FLIGHT_RESULTS_MODULE.UPSELL.CUSTOMIZE_YOR_RATE' | transloco }}
        </span>
        <app-ds-button-icon
          [icon]="icons.Close"
          [buttonSize]="buttonIconSize"
          [iconSize]="16"
          (clickEvent)="toggleShowForm.emit()">
        </app-ds-button-icon>
      </div>
      <p class="description">
        {{ 'FLIGHT_RESULTS_MODULE.UPSELL.CHOOSE_THE_RATE' | transloco }}
      </p>
    </div>
    <div class="form-cont-parent">
      <div class="upsell-table" [attr.data-count]="upsellData?.length">
        <table>
          <thead>
            <tr>
              <th></th>
              <th class="upsell-column-item" 
                *ngFor="let option of fligthsUpsell?.UpsellOptions;let i=index">
                {{ option?.Families[0]?.Name | uppercase }}
              </th>
            </tr>
          </thead>        
          <tbody>
            <tr *ngIf="hasCabins">
              <td class="upsell-column title"> 
                <strong>
                  {{ 'FLIGHT_RESULTS_MODULE.UPSELL.CABIN' | transloco }}
                </strong>
              </td>
              <td class="upsell-column-item item-nowrap" 
                *ngFor="let item of fligthsUpsell?.UpsellOptions">
                <ng-container *ngIf="item?.CabinTypeByFlights">
                  <ng-container *ngFor="let cabin of getflightClassUnique(item?.CabinTypeByFlights); let last = last">
                    {{ flightClassText(cabin) | titlecase }}
                    <span *ngIf="!last"> {{'INSTALLMENTS_INFO.SUBTITLE_LAST_CONCAT' | transloco}}</span>
                  </ng-container>
                </ng-container>
              </td>
            </tr>
            <tr *ngFor="let item of upsellData"> 
              <td class="upsell-column title"> 
                <strong>
                  {{ item?.optionType?.Title | capitalize }}
                </strong>
              </td>
              <td class="upsell-column-item item-nowrap" 
                *ngFor="let optionInclusion of item.optionInclusions">
                <span *ngIf="showTitle(item.optionType, optionInclusion.option); else icon">
                  <span *ngIf="isIncluded(item.optionType, optionInclusion.option)" class="icon with-text">
                    <app-ds-icon
                      [icon]="iconState(item.optionType, optionInclusion.option)"
                      [color]="classState(item.optionType, optionInclusion.option)"
                      [size]="14">
                    </app-ds-icon>
                  </span>
                  {{ showTitle(item.optionType, optionInclusion.option) | capitalize }}
                </span>
                <ng-template #icon>
                  <span *ngIf="!isAtCharge(item.optionType, optionInclusion.option); else atCharge" class="icon">
                    <app-ds-icon
                      [icon]="iconState(item.optionType, optionInclusion.option)"
                      [color]="classState(item.optionType, optionInclusion.option)"
                      [size]="14">
                    </app-ds-icon>
                  </span>
                  <ng-template #atCharge>
                    <span>
                      {{ 'FLIGHT_RESULTS_MODULE.UPSELL.AT_CHARGES' | transloco }}
                    </span>
                  </ng-template>
                </ng-template>
              </td>
            </tr> 
          </tbody>
          <tfoot>
            <tr>
              <td></td>
              <td class="upsell-column-item" 
                *ngFor="let option of fligthsUpsell?.UpsellOptions;let i=index">
                <div class="footer">
                  <!-- Temporarily Disabled -->
                  <ng-container *ngIf="false">
                    <div *ngIf="option.HasPrivateFare" class="product-tag">
                      <app-member-rate-tag [tagType]="tagType"></app-member-rate-tag>
                    </div>
                  </ng-container>
                  <!-- / Temporarily Disabled -->
                  <div class="radio">
                    <app-ds-radio-button
                      [checked]="isOptionChecked(option.OptionId)"
                      [title]="{
                        Label: calcUpsellItemValues(option.Amount?.Fare, option.Amount?.Taxes) | currencyFormat: option.Amount?.CurrencyCode,
                        CustomColor: radioLabelColor
                      }"
                      (radioOnChecked)="updateSelectedOption(option, i)">
                    </app-ds-radio-button>
                  </div>
                </div>
              </td>
            </tr>
          </tfoot>
        </table>
      </div>
    </div>
    <div class="desktopUpsell__footer-container">
      <div class="desktopUpsell__footer-container__btn">
        <app-ds-button
          [isDisabled]="!isOptionSelected"
          [labels]="{ ButtonLabel: 'BUTTONS.CONTINUE' | transloco }"
          (clickEvent)="selectUpsell()">
        </app-ds-button>
      </div>
    </div>
  </ng-template>
</div>
